import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_JOB_BOARD_API_URL;

// ================================
// GET ADMIN DASHBOARD DATA
// ================================
export const getAdminDashboard = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/admin/dashboard`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to load admin dashboard", error);
    throw error;
  }
};
